import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/tgc/2025-winter/Index.vue')
const Winners = () => import('../activity/tgc/2025-winter/winners/Index.vue')
const IndexSub = () => import('../activity/tgc/2025-winter-sub/Index.vue')
const RewardsSub = () => import('../activity/tgc/2025-winter-sub/Rewards.vue')
const IndexClothes = () => import('../activity/tgc/2026-clothes/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/tgc/2025-winter',
  name: 'activity_tgc_2025_winter',
  component: Index,
  redirect: '/activity/tgc/2025-winter/winners',
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: 'TGC体感癫疯赛',
  },
}

export const winnersRoute: RouteConfig = {
  path: '/activity/tgc/2025-winter/winners',
  name: 'activity_tgc_2025_winter_winners',
  component: Winners,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: 'TGC冬季金牌团队颁奖礼',
  },
}

export const indexSubRoute: RouteConfig = {
  path: '/activity/tgc/2025-winter-sub',
  name: 'activity_tgc_2025_winter_sub',
  component: IndexSub,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: 'TGC分会场体感乐园',
  },
}

export const rewardsSubRoute: RouteConfig = {
  path: '/activity/tgc/2025-winter-sub/rewards',
  name: 'activity_tgc_2025_winter_sub_rewards',
  component: RewardsSub,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '抽奖记录',
  },
}

export const indexClothesRoute: RouteConfig = {
  path: '/activity/tgc/2026-clothes',
  name: 'activity_tgc_clothes',
  component: IndexClothes,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '独家定制运动服',
    ignoreLogin: true,
  },
}

export default [indexRoute, winnersRoute, indexSubRoute, rewardsSubRoute, indexClothesRoute]
